/**
 * External dependencies
 */
import { SVG, Path, Circle } from '@wordpress/primitives';

export const location = (
	<SVG width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M40.8454 24.5546C40.8454 38.7862 23.9999 48.0803 23.9999 48.0803C23.9999 48.0803 7.1543 38.7862 7.1543 24.5546C7.1543 15.4115 14.8567 7.99951 23.9999 7.99951C33.143 7.99951 40.8454 15.4115 40.8454 24.5546Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>

		<Circle
			cx="24.0004"
			cy="21.9408"
			r="5.22793"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
	</SVG>
);
